import gql from 'graphql-tag';

export const UnifiedUserQuery = gql`
	query UnifiedUserQuery {
		isSiteAdmin
		hasUserAccessAdminRole
		userCanCreateContent
		isNewUser
		currentConfluenceUser {
			isAnonymous
		}
		user(current: true) {
			id
			displayName
			photos {
				value
				isPrimary
			}
			emails {
				value
				isPrimary
			}
			confluence {
				permissionType
				space {
					id
				}
				operations {
					operation
					targetType
				}
			}
		}
	}
`;
